import React from 'react';

import {
    Edit,
    SelectInput,
    SimpleForm,
    TextInput,
    DateInput,
} from 'react-admin';
import { typesOptions } from './consts';
import DropdownSearchInput from './components/dropdownSearchInput';

const TaskEdit = props => (
    <Edit undoable={false} {...props}>
        <SimpleForm variant="outlined">
            <TextInput disabled source="id" />
            <DateInput source="date" />
            {/*<TextInput source="type" />*/}
            {/*<SelectInput source="type" choices={typesOptions} />*/}
            <SelectInput
                source="status"
                choices={[
                    { id: 'new', name: 'new' },
                    { id: 'running', name: 'running' },
                    { id: 'complete', name: 'complete' },
                    { id: 'failed', name: 'failed' },
                    { id: 'paused', name: 'paused' },
                ]}
            />
            <DropdownSearchInput
                source="type"
                placeholder="Type"
                label="Type"
                choices={typesOptions}
            />
            <TextInput
                source="data"
                parse={v => JSON.parse(v)}
                format={v => JSON.stringify(v)}
                fullWidth={false}
                multiline={true}
            />
            <div style={{ height: '19rem' }} />
        </SimpleForm>
    </Edit>
);

export default TaskEdit;
